import { render, staticRenderFns } from "./Foyer.vue?vue&type=template&id=89b71cfa&"
import script from "./Foyer.vue?vue&type=script&lang=js&"
export * from "./Foyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports